import { Injectable } from '@angular/core';
import { BusinessRegion, BusinessRegionResponseData } from '@city/const';
import { GeoPoint } from '@core/const';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { CityActions } from '../store/actions';
import { StateWithCity } from '../store/city-state';
import { CitySelectors } from '../store/selectors';
import { BaseStoreFacade } from './base-store.facade';

@Injectable({
  providedIn: 'root',
})
export class BusinessRegionFacade {
  constructor(
    private store: Store<StateWithCity>,
    private baseStoreFacade: BaseStoreFacade,
  ) {}

  loadBusinessRegionForPoint(point: GeoPoint): void {
    this.store.dispatch(new CityActions.LoadBusinessRegionFromCoords(point));
  }

  getBusinessRegionForPoint(): Observable<BusinessRegionResponseData> {
    return this.store.pipe(select(CitySelectors.getBusinessRegionForPoint));
  }

  getBusinessRegion(): Observable<BusinessRegion | undefined> {
    return this.store.pipe(
      select(CitySelectors.getBusinessRegionValue),
      switchMap((businessRegion?: BusinessRegion) =>
        this.baseStoreFacade.getActiveCode().pipe(
          map((code: string) => {
            if (businessRegion?.point.slug === code) {
              return businessRegion;
            } else return undefined;
          }),
        ),
      ),
    );
  }

  getBusinessRegionLoading(): Observable<boolean> {
    return this.store.pipe(select(CitySelectors.getBusinessRegionLoading));
  }

  getBusinessRegionError(): Observable<boolean> {
    return this.store.pipe(select(CitySelectors.getBusinessRegionError));
  }

  getBusinessRegionSuccess(): Observable<boolean> {
    return this.store.pipe(select(CitySelectors.getBusinessRegionSuccess));
  }

  setBusinessRegion(businessRegion: BusinessRegion): void {
    this.store.dispatch(new CityActions.BusinessRegionLoadSuccess(businessRegion));
  }

  resetBusinessRegion(): void {
    this.store.dispatch(new CityActions.BusinessRegionReset());
  }

  getNoDeliveryIsShowing(): Observable<boolean> {
    return this.store.pipe(select(CitySelectors.getNoDeliveryIsShowingValue));
  }

  setShownNoDelivery(): void {
    this.store.dispatch(new CityActions.CityMarkNotShownNoDelivery());
  }
}
